import { Component, Input } from '@angular/core';

@Component({
    selector: 'gbc-form-container',
    templateUrl: './form-container.component.html',
    styleUrls: ['./form-container.component.scss'],
    standalone: true,
})
export class FormContainerComponent {}
